
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.337 13.39l-2.803-1.622a4.49 4.49 0 01-7.074 0l-2.804 1.623-1.12.643a9.73 9.73 0 001.094 1.327 9 9 0 0012.733 0 9.66 9.66 0 001.093-1.327l-1.119-.643zm.026-10.776A8.929 8.929 0 009.64 0v4.558A4.48 4.48 0 0113.485 9a4.683 4.683 0 01-.308 1.648l2.804 1.635 1.106.644A8.806 8.806 0 0018 8.987a8.99 8.99 0 00-2.637-6.373zm-12.733 0A9.024 9.024 0 00.907 12.927l1.106-.644 2.803-1.635A4.683 4.683 0 014.509 9a4.487 4.487 0 013.846-4.442V0A8.928 8.928 0 002.63 2.614z","fill":"currentColor"}})])
          )
        }
      }
    